module.exports = __webpack_public_path__ + "static/media/onjob-icon.3c091cc7.svg";